import { useState } from 'react';
import MRETable from '../components/MRETable';
import MainMRETable from '../components/MainMRETable';
import { checkRoleActionAccess } from 'routes/checkRoleAccess';
import { useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';
import { UserCredential } from 'features/login/models';
import { ActionEnum, MenuEnum } from 'routes/models';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import DefaultModal from 'components/Modal/DefaultModal';
import JobImport from '../../job/components/JobImport';
import QCMRETable from '../components/QCMRETable';

const QCMREPage = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const user = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential)
    );

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
    };

    return (
        <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <div className="flex justify-items-center">
                <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                    QC MRE
                </h1>
            </div>
            <div className="mt-3">
                <QCMRETable />
                <MainMRETable />
            </div>
        </div>
    );
};

export default QCMREPage;
